
import { Component, Prop, Vue, Watch } from 'vue-facing-decorator'

@Component({
})
export default class extends Vue {
  @Prop()
  modelValue: any


  get initValue() {
    if (this.modelValue == undefined || this.modelValue === "") {
      return undefined;
    }
    return Number(this.modelValue);
  }

  set initValue(v) {
    this.$emit("update:modelValue", v);
  }

  source = { list: [] };
  created() {
    this.getList()
  }

  async getList() {
    let { error, data } = await this.$post("/manager/postage/postage-list", {
      pageSize: 100,
    });
    if (error) return;
    this.source = data;
  }
}
